import type { Capabilities } from '@rtkwlf/rendall';

import { FeatureFlagGuard } from '@platform/client/feature-flags';
import type { FeatureConfig } from '@platform/client/features';

import { LegacyCapabilitiesGuard } from '@packages/components/capabilities/legacy-capabilities-guard';
import { hasAnyRequiredProperty } from '@packages/utils/has-any-required-property';

import i18n from './locales/i18n';

const tipSkuCapability: Partial<Capabilities> = {
  canViewAllTickets: true,
};

export default {
  routes: [
    {
      path: 'reports/tip-sku',
      element: <LegacyCapabilitiesGuard capabilities={tipSkuCapability} />,
      children: [
        {
          path: 'threat-intelligence',
          element: <FeatureFlagGuard featureFlag="THREAT_INTEL_SKU" />,
          children: [
            {
              index: true,
              lazy: () => import('./bulletin-list/bulletin-list.page'),
            },
            {
              path: ':idSlug?',
              lazy: () => import('./bulletin-details/bulletin-details.page'),
            },
          ],
        },
        {
          path: 'threat-intelligence-feed',
          element: <FeatureFlagGuard featureFlag="THREAT_INTEL_FEED" />,
          lazy: () => import('./intel-feed/intel-feed'),
        },
      ],
    },
  ],
  navigation: ({ featureFlags, legacyCapabilities }) => {
    const hasTipSkuAccess =
      legacyCapabilities &&
      hasAnyRequiredProperty(tipSkuCapability, legacyCapabilities);

    if (!hasTipSkuAccess) return {};

    return {
      threatIntelligence: {
        threatReportAndWebinars: featureFlags?.THREAT_INTEL_SKU
          ? {
              title: i18n.t('reports:menu.threatReportAndWebinars'),
              segment: '/reports/tip-sku/threat-intelligence',
            }
          : null,
        iocBlocklists: {
          title: i18n.t('reports:menu.iocBlocklists'),
          segment: '/resource-center/downloads#threat-intelligence-downloads',
          isBookmark: true,
        },
        stixTaxiiFeeds: featureFlags?.THREAT_INTEL_FEED
          ? {
              title: i18n.t('reports:menu.threatIntelligenceFeed'),
              segment: '/reports/tip-sku/threat-intelligence-feed',
            }
          : null,
      },
    };
  },
} satisfies FeatureConfig;
